/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Document/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import File from './File/index'
import Folder from './Folder/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Document({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/Documents/Body/Content/Document"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Folder'
let documentTypeValueData = fromData.useDataValue({ viewPath,
context: 'document',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: documentTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Folder'}>
<Folder
  viewPath={`${viewPath}/Folder`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'File'}>
<File
  viewPath={`${viewPath}/File`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}